import { jsx as o, jsxs as b, Fragment as v } from "react/jsx-runtime";
import { Intent as _, Popover as D, Menu as x, MenuItem as I, MenuDivider as E, Icon as f } from "@blueprintjs/core";
import { IconNames as h } from "@blueprintjs/icons";
import { ActionButtonText as C, Button as N } from "@strata/react-buttons";
import l from "classnames";
import { useState as w, forwardRef as g } from "react";
import "./main.scss";
const R = {
  NONE: _.NONE,
  DANGER: _.DANGER
}, a = ({
  menuItemArray: t = [],
  additionalMenuItemArray: e = void 0,
  menuContent: r = void 0,
  isOpen: p,
  onInteraction: s,
  onClose: c,
  onClosed: i,
  className: u,
  popoverClassName: d,
  portalClassName: m,
  children: O
}) => /* @__PURE__ */ o(
  D,
  {
    className: u,
    popoverClassName: l("sds_dropdown-menu", d),
    portalClassName: l("sds_dropdown-menu__popover-portal", m),
    isOpen: p,
    onInteraction: s,
    onClose: c,
    onClosed: i,
    autoFocus: !1,
    placement: "bottom",
    modifiers: { preventOverflow: { options: { padding: 5 } } },
    content: /* @__PURE__ */ o(x, { children: r ?? /* @__PURE__ */ b(v, { children: [
      t.map((n) => /* @__PURE__ */ o(
        I,
        {
          icon: n.icon,
          text: n.text,
          labelElement: n.labelElement,
          onClick: n.onItemClick,
          disabled: n.disabled,
          intent: n == null ? void 0 : n.intent
        },
        n.text
      )),
      t.length > 0 && (e ?? []).length > 0 && /* @__PURE__ */ o(E, {}),
      e == null ? void 0 : e.map((n) => /* @__PURE__ */ o(
        I,
        {
          text: n.text,
          onClick: n.onItemClick,
          disabled: n.disabled,
          intent: n == null ? void 0 : n.intent
        },
        n.text
      ))
    ] }) }),
    children: O
  }
);
a.Intent = R;
const G = ({
  label: t,
  disabled: e = !1,
  menuItems: r,
  additionalMenuItems: p = void 0
}) => {
  const [s, c] = w(!1);
  return /* @__PURE__ */ o(
    a,
    {
      menuItemArray: r,
      additionalMenuItemArray: p,
      isOpen: s,
      onInteraction: c,
      children: /* @__PURE__ */ o(
        C,
        {
          label: t,
          rightIcon: /* @__PURE__ */ o(
            f,
            {
              className: l("sds_button-with-menu__chevron", {
                "sds_button-with-menu__chevron--up": s
              }),
              icon: h.CHEVRON_DOWN
            }
          ),
          disabled: e
        }
      )
    }
  );
}, H = (() => {
  const t = g(
    ({
      label: e,
      intent: r = N.Intent.NONE,
      disabled: p = !1,
      menuItems: s,
      additionalMenuItems: c,
      autoFocus: i
    }, u) => {
      const [d, m] = w(!1);
      return /* @__PURE__ */ o(
        a,
        {
          menuItemArray: s,
          additionalMenuItemArray: c,
          isOpen: d,
          onInteraction: m,
          children: /* @__PURE__ */ o(
            N,
            {
              intent: r,
              label: e,
              disabled: p,
              type: "button",
              autoFocus: i,
              ref: u,
              iconAfterLabel: /* @__PURE__ */ o(
                f,
                {
                  className: l("sds_button-with-menu__chevron", {
                    "sds_button-with-menu__chevron--up": d
                  }),
                  icon: h.CHEVRON_DOWN
                }
              )
            }
          )
        }
      );
    }
  );
  return t.Intent = N.Intent, t.DropdownIntent = a.Intent, t;
})();
export {
  G as ActionButtonTextDropdownMenu,
  H as ButtonWithDropdownMenu,
  a as DropdownMenu
};
//# sourceMappingURL=index.js.map
